import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import { Icon, RSelect } from "../../../components/Component";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { validate } from "../utils";
import { useSelector, useDispatch } from "react-redux";
import { addCommunityTeam } from "../../../redux/actions/community-teams";
import ChannelPartnersFilter from "../../components/filter-components/ChannelPartnersFilter"; // Added import

const TeamCreateModal = ({ isOpen, toggleFn, refreshFn, viewType }) => {
  const axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const isChannelPartnerView = viewType === "channelPartnerTeams";
  const modalTitle = isChannelPartnerView ? "Add Channel Partner Team" : "Add Master Community";
  const submitButtonText = isChannelPartnerView ? "Add Channel Partner Team" : "Add Master Community";
  const teamNameLabel = isChannelPartnerView ? "Channel Partner Team Name *" : "Master Community Name *";

  const [teamName, setTeamName] = useState("");
  const [possibleTeamMembers, setPossibleTeamMembers] = useState([]); // Initialize as empty array
  const [possibleCommunities, setPossibleCommunities] = useState([]); // Initialize as empty array

  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedCommunities, setSelectedCommunities] = useState([]);
  const [selectedTeamLeader, setselectedTeamLeader] = useState(null);
  const [selectedChannelPartnerFilter, setSelectedChannelPartnerFilter] = useState(null); // Added state for CP filter

  const { loading, error } = useSelector(state => state.communityTeam);

  const fetchDataForFields = async () => {
    const agentRes = await axios.get("/agent");
    const communityRes = await axios.get("/community");
    if (agentRes.data) {
      setPossibleTeamMembers(agentRes.data);
    }
    if (communityRes.data) {
      // only take communities not assigned to teams
      setPossibleCommunities(
        communityRes.data.filter((c) => c?.team_id == null)
      );
    }
  };

  const handleMembersChange = (e) => {
    let values = selectedMembers
      ? selectedMembers
        // eslint-disable-next-line eqeqeq
        .filter((x) => x?.value != undefined)
        .map((x) => x?.value)
      : [];
    e?.forEach((member) => {
      values.push(member.value);
    });
    setSelectedMembers(values);
  };

  const handleCommunitiesChange = (e) => {
    let values = selectedCommunities
      ? selectedCommunities
        // eslint-disable-next-line eqeqeq
        .filter((x) => x?.value != undefined)
        .map((x) => x?.value)
      : [];
    e?.forEach((community) => values.push(community.value));
    setSelectedCommunities(values);
  };

  const handleCreateFormSubmit = async (formEvent) => {
    formEvent.preventDefault();

    if (isChannelPartnerView && !selectedChannelPartnerFilter?.value) {
      toast.error("Please select a Channel Partner.");
      return;
    }
    // Adjusted validation for CPT, communities might not be mandatory
    // For CPT, selectedCommunities will be an empty array, so validation should pass for it.
    if (!validate(teamName, selectedMembers, isChannelPartnerView ? [] : selectedCommunities, selectedTeamLeader, isChannelPartnerView)) {
      return;
    }
    const newTeamData = {
      teamName,
      members: selectedMembers,
      // Conditionally add communities. If CPT, it might be empty or not applicable.
      communities: isChannelPartnerView ? [] : selectedCommunities,
    };

    if (isChannelPartnerView) {
      newTeamData.partner = selectedChannelPartnerFilter?.value;
    }

    dispatch(
      addCommunityTeam(
        axios,
        newTeamData,
        () => { // This is the 'callback' which runs in all cases (finally block in action)
          handleModalClose(); // Use the consolidated close handler
        },
        () => { // This is the 'successCallback'
          toast.success(`${isChannelPartnerView ? "Channel Partner Team" : "Master Community"} created successfully!`);
          refreshFn();
        }
      )
    );
  };

  useEffect(() => {
    if (isOpen) { // Fetch data only when modal is open
      fetchDataForFields();
    } else {
      // Reset fields when modal is closed
      setTeamName("");
      setSelectedMembers([]);
      setSelectedCommunities([]);
      setSelectedChannelPartnerFilter(null);
      setselectedTeamLeader(null);
      // setPossibleTeamMembers([]); // Optionally clear options if they should always be fresh
      // setPossibleCommunities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]); // Add isOpen to dependency array

  useEffect(() => {
    if (error) {
      toast.error(error.message ?? `Error occurred while creating ${isChannelPartnerView ? "channel partner team" : "master community"}.`);
    }
  }, [error, isChannelPartnerView]);

  const handleModalClose = (ev) => {
    if (ev) ev.preventDefault();
    toggleFn();
    // Reset fields on explicit close action as well
    setTeamName("");
    setSelectedMembers([]);
    setSelectedCommunities([]);
    setSelectedChannelPartnerFilter(null);
    setselectedTeamLeader(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleModalClose} // Use custom close handler
      className="modal-dialog-centered"
      size="lg"
    >
      <ModalBody>
        <div className="nk-tnx-details mt-sm-3">
          <a href="#cancel" className="close" onClick={handleModalClose}>
            {" "}
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="nk-modal-head mb-3">
            <h5 className="title">{modalTitle}</h5>
          </div>
        </div>
        <div className="p-2">
          <form onSubmit={handleCreateFormSubmit}>
            <Row className="g-3">

              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="teamName">
                    {teamNameLabel}
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      className="form-control"
                      name="teamName"
                      required
                      value={teamName}
                      onChange={(e) => setTeamName(e.target.value)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={isChannelPartnerView ? "8" : "8"}>
                <div className="form-group">
                  <label className="form-label" htmlFor="teamMembers">
                    Agents *
                  </label>
                  <div className="form-control-wrap">
                    {possibleTeamMembers.length > 0 && (
                      <RSelect
                        name="teamMembers"
                        placeholder="Select agents..."
                        isMulti
                        required
                        options={possibleTeamMembers.map((member) => ({
                          ...member,
                          value: member?.userId,
                          label: `${member?.user?.first_name} ${member?.user?.last_name}`,
                        }))}
                        onChange={(e) => handleMembersChange(e)}
                        className="customInput"
                        value={selectedMembers.map(memberValue => { // Ensure RSelect displays selected values
                          const fullMember = possibleTeamMembers.find(m => m.userId === memberValue);
                          return fullMember ? {
                            ...fullMember,
                            value: fullMember?.userId,
                            label: `${fullMember?.user?.first_name} ${fullMember?.user?.last_name}`
                          } : null;
                        }).filter(Boolean)}
                      />
                    )}
                  </div>
                </div>
              </Col>
              {isChannelPartnerView && (
                <Col md="12"> {/* Changed to full width for better layout */}
                  <div className="form-group">
                    <label className="form-label" htmlFor="channelPartner">
                      Channel Partner *
                    </label>
                    <ChannelPartnersFilter
                      stateVar={selectedChannelPartnerFilter}
                      onChange={(option) => setSelectedChannelPartnerFilter(option)}
                      isMulti={false}
                      className="customInput" // Added for consistency
                    />
                  </div>
                </Col>
              )}

              {!isChannelPartnerView && ( // Conditionally render Communities/Places field
                <Col md="12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="teamCommunities">
                      Places *
                    </label>
                    <div className="form-control-wrap">
                      {possibleCommunities.length > 0 && (
                        <RSelect
                          name="teamCommunities"
                          placeholder="Select places..."
                          isMulti
                          required={!isChannelPartnerView} // Required only if not CPT
                          options={possibleCommunities.map((community) => ({
                            value: community?._id ?? community?.id,
                            label: `${community?.community}`,
                          }))}
                          onChange={(e) => handleCommunitiesChange(e)}
                          className="customInput"
                          value={selectedCommunities.map(communityValue => { // Ensure RSelect displays selected values
                            const fullCommunity = possibleCommunities.find(c => (c._id ?? c.id) === communityValue);
                            return fullCommunity ? {
                              value: fullCommunity?._id ?? fullCommunity?.id,
                              label: `${fullCommunity?.community}`
                            } : null;
                          }).filter(Boolean)}
                        />
                      )}
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <Col size="12" className="text-end mt-4">
              <Button color="primary" size="lg" disabled={loading}>
                {loading ? "Adding..." : submitButtonText}
              </Button>
            </Col>
          </form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TeamCreateModal;
